export default __webpack_public_path__ + "locales/ja-JP/InviteDialog.json?hash=59ccf6a30e124e2fa23833d5b5b87e87";